import React from 'react';
import './RDivider.scss';

function RDivider() {
	return <div className="rd-divider" />;
}

export default RDivider;
